import { Floor, Zone } from '../api';

export default (floors: Floor[], floorID: string, zoneID?: string): Floor | undefined => {
  const floor: Floor | undefined = floors.find(floor => floor.ID === floorID);

  if (floor && zoneID) {
    const zone: Zone | undefined = floor.zones.find(zone => zone.ID === zoneID);

    return {
      ...floor,
      name: zone?.name || floor.name,
      description: zone?.description || floor.description,
      zones: zone ? [zone] : []
    };
  } else {
    return floor;
  }
};
